import React from "react";
import { Box, Tooltip } from "@mui/material";
import { ManageHistoryOutlined } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useDispatchWrapper } from "../../hooks";
import { IStoreState } from "../../redux/initialStoreState";
import { LoadState } from "../../constants/enums";
import { clearChangeHistoryState } from "../../redux/changeHistory/changeHistorySlice";
import { fetchChangeHistoryAsync } from "../../redux/changeHistory/changeHistoryThunk";
import { RightPanel } from "../RightPanel";
import { PageLoader } from "../PageLoader/PageLoader";
import { FilterPanel } from "./FilterPanel";
import TimelineList from "./TimelineList";
import { IChangeHistoryTimelineProps, IChangeHistoryFilters } from "./ChangeHistoryTimeline.types";
import { DEFAULT_HEADING } from "./constants";

export const ChangeHistoryTimeline: React.FC<IChangeHistoryTimelineProps> = (props) => {
  const { module_name, entry_id, heading = DEFAULT_HEADING } = props;
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatchWrapper();

  const { loading } = useSelector(
    (state: IStoreState) => state.changeHistory
  );

  const handleOpen = () => {
    dispatch(clearChangeHistoryState());
    dispatch(
      fetchChangeHistoryAsync({
        module_name,
        ...(entry_id ? { entry_id } : {}),
      })
    );
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleApplyFilters = (filters: IChangeHistoryFilters) => {
    dispatch(
      fetchChangeHistoryAsync({
        module_name,
        ...(entry_id ? { entry_id } : {}),
        ...(filters.entry_id ? { entry_id: filters.entry_id } : {}),
        ...(filters.user_fact_id ? { user_fact_id: filters.user_fact_id } : {}),
        ...(filters.action ? { action: filters.action } : {}),
        ...(filters.from_date ? { from_date: filters.from_date } : {}),
        ...(filters.to_date ? { to_date: filters.to_date } : {}),
      })
    );
  };

  const handleClearFilters = () => {
    dispatch(
      fetchChangeHistoryAsync({
        module_name,
        ...(entry_id ? { entry_id } : {}),
      })
    );
  };

  const handleRetry = () => {
    dispatch(
      fetchChangeHistoryAsync({
        module_name,
        ...(entry_id ? { entry_id } : {}),
      })
    );
  };

  return (
    <>
      <Tooltip title="View Change History">
          <ManageHistoryOutlined  onClick={handleOpen} color="primary" fontSize="small" />

      </Tooltip>

      {open && (
        <RightPanel
          open={true}
          heading={heading}
          onClose={handleClose}
          width="55%"
          version="v2"
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              overflowY: "auto",
            }}
          >
            <FilterPanel
              onApplyFilters={handleApplyFilters}
              onClearFilters={handleClearFilters}
              hideEntryIdFilter={!!entry_id}
            />
            <PageLoader loading={loading === LoadState.InProgress}>
              <TimelineList onRetry={handleRetry} />
            </PageLoader>
          </Box>
        </RightPanel>
      )}
    </>
  );
};
